var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");
name.prefix = require("./prefix");
name.suffix = require("./suffix");
name.name = require("./name");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/name/index.js
 ** module id = 696
 ** module chunks = 0
 **/